<!--
 * @Description: 项目执行人女性年龄分布
 * @Date: 2024-01-11 13:52:40
-->
<template>
  <div class="bi-tmpl-detail__right__cmpt">
    <div>
      <span class="bi-tmpl-detail__right__cmpt__title">
        {{ curItem.title }}
      </span>
      <span v-if="curItem.tips" class="bi-tmpl-detail__right__cmpt__tips">
        {{ curItem.tips }}
      </span>
    </div>
    <Carousel ref="carouselRef" :itemHeight="200" :itemWidth="420 + 56">
      <div
        style="height: 200px; width: 100%"
        v-for="(item, index) in TYPE_MAPPING"
        :key="index"
        @click="onChange(item.value)"
      >
        <BaseCard style="width: 420px; height: 200px">
          <BaseRadio
            class="bi-tmpl-detail__right__cmpt__radio bi-tmpl-detail__right__cmpt__radio--w"
            :value="item.value"
            :model-value="curItem.value"
          >
            <div
              v-if="item.svg"
              v-html="item.svg"
              style="margin-top: 24px"
            ></div>
            <div
              v-else
              style="height: 120px; display: flex; align-items: center"
            >
              <component :is="cmpName(item.moduleType)" />
            </div>
          </BaseRadio>
        </BaseCard>
      </div>
    </Carousel>
    <p style="font-size: 14px; color: #4c4c4c; margin-top: 16px">
      {{
        `本报告样本，项目执行人数为21人。男性人数为10人，占比47.62%；女性别人数为11人，占比为52.38%。18-30岁之间男性人数为3人，占比14.28%。女性别人口为3人，占比14.28%；31-40岁之间男性人口为4人，占比19.05%。女性别人口大4人，占比19.05%; 41岁以上男性人数为3人，占比14.28%。女性为4人，占比19.05%。`
      }}
    </p>
  </div>
</template>

<script lang="ts" setup>
import { BaseRadio } from 'xrk-components';
import { BaseCard } from 'xrk-components';
import { Carousel } from '@/components/base/carousel';
import PcModuleWoManSex from '../../../../../bi-pc-module/pc-module-age-woman/index';

import { useDetailCmpt } from '@V/bi-tmpl/src/hooks';
import { commonSVG } from '../../../commonSVG';

const CHILD_KEY = '4_2_4';
const TYPE_MAPPING: Array<{
  value: any;
  moduleType?: any;
  index: number;
  svg?: string;
}> = [
  ...[1, 2, 3, 4, 5, 6].map(i => {
    return {
      value: 'pc-module-age-distribution-' + i,
      moduleType: 'pc-module-age-woman-' + i,
      index: i
    };
  }),
  {
    svg: commonSVG,
    value: [2, 3, 9, 6, 10, 7].join(','),
    index: 6
  }
];

const cmpName = name => {
  return PcModuleWoManSex.filter(comp => comp.__name === name)[0];
};

const { curItem, onChange } = useDetailCmpt({ childKey: CHILD_KEY });
</script>
